/**
 * @module beebee-base/lib/utility/_shared
 * @description Shared constants used across multiple utility sub-modules.
 */

/** Lista valute supportate */
const listCurrency = Object.freeze(['AUD', 'CAD', 'EUR', 'GBP', 'CHF', 'USD']);

export { listCurrency };
//# sourceMappingURL=_shared.js.map
